export const setUser = (payload) => ({
    type: 'SET_USER',
    payload
});

export const setSiteFontSize = (payload) => ({
    type: 'SET_SITE_FONT_SIZE',
    payload
});

export const setDarkMode = (payload) => ({
    type: 'SET_DARK_MODE',
    payload
});
